// extracted by mini-css-extract-plugin
export var aiStarIcon = "_m3-2";
export var container = "_m3-4";
export var dismissButton = "_m3-3";
export var hasPaddingBottom = "_m3-6";
export var last = "_m3-e";
export var scrollbarThumb = "_m3-c";
export var scrollbarTrack = "_m3-b";
export var selected = "_m3-9";
export var spin = "_m3-1";
export var spinning = "_m3-0";
export var suggestionItem = "_m3-d";
export var suggestionsPanel = "_m3-5";
export var tonePill = "_m3-8";
export var tonesContainer = "_m3-7";
export var unselected = "_m3-a";